import { Injectable } from '@angular/core';

import { RequestsGetDataApi } from './requests-get-data-api.service';
import { TranslateService } from '@ngx-translate/core';
import { Operation, ParticipantDTO, ParticipantVSDTO, VideoSelfingDTO } from '../model/requests-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { IneDTO } from '../model/ine-model';

@Injectable()
export class RequestsGetDataStore {
  public requestDigitalID = new BehaviorSubject<string>(null);
  public requestDigitalID$ = this.requestDigitalID.asObservable();

  constructor(private requestsGetDataApi: RequestsGetDataApi, private translate: TranslateService) {}

  public getparticipantsVideoSelfing(videoSelfing: VideoSelfingDTO): Observable<IneDTO> {
    return this.requestsGetDataApi.getPendingVideoSelfing(videoSelfing);
  }

  public sendSMSVideoSelfing(participantVSDTO: any): Observable<any> {
    return this.requestsGetDataApi.postSendSMSVideoSelfing(participantVSDTO);
  }

  setOperationVideoselfing(operation: Operation) {
    localStorage.setItem('videoselfing', JSON.stringify(operation));
  }

  getOperationVideoselfing() {
    return JSON.parse(localStorage.getItem('videoselfing'));
  }

  public setRequestDigitalID(value: string) {
    this.requestDigitalID.next(value);
  }

  public getRequestDigitalID() {
    return this.requestDigitalID.value;
  }
}
